import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <nav className="footer-nav">
        <Link to="/about">このサイトについて</Link>
        <Link to="/privacy-policy">プライバシーポリシー</Link>
      </nav>
      <p className="footer-copy">&copy; 2026 Sail Alert URAGA</p>
    </footer>
  );
};

export default Footer;
